import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "vgi_cookie_consent";
const SIX_MONTHS = 1000 * 60 * 60 * 24 * 182;

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { value, ts } = JSON.parse(raw);
    if (!ts || Date.now() - ts > SIX_MONTHS) { localStorage.removeItem(KEY); return null; }
    return value;
  } catch { return null; }
}

function loadAnalytics() {
  if (typeof window !== "undefined" && typeof window.__loadPostHog === "function") window.__loadPostHog();
  window.dispatchEvent(new Event("vgi-cookies-accepted"));
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c === "accepted") loadAnalytics();
    else if (c === null) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, JSON.stringify({ value, ts: Date.now() }));
    setVisible(false);
    if (value === "accepted") loadAnalytics();
  };

  if (!visible) return null;
  const btn = { flex: 1, minWidth: '120px', padding: '12px 20px', borderRadius: '100px', fontWeight: 700, fontSize: '14px', cursor: 'pointer', border: '2px solid #8B0000' };
  return (
    <div data-testid="cookie-banner" role="dialog" aria-label="Cookies" style={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 9999, backgroundColor: '#1a1a1a', color: '#fff', padding: '16px 20px', boxShadow: '0 -4px 24px rgba(0,0,0,0.3)' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '16px' }}>
        <p style={{ margin: 0, flex: '1 1 320px', fontSize: '14px', lineHeight: 1.6, color: '#e5e5e5' }}>
          Nous utilisons des cookies de mesure d'audience.{" "}
          <Link to="/mentions-legales" style={{ color: '#fff', textDecoration: 'underline' }}>En savoir plus</Link>
        </p>
        <div style={{ display: 'flex', gap: '10px', flex: '1 1 260px' }}>
          <button data-testid="cookie-accept" onClick={() => choose("accepted")} style={{ ...btn, backgroundColor: '#8B0000', color: '#fff' }}>Accepter</button>
          <button data-testid="cookie-refuse" onClick={() => choose("refused")} style={{ ...btn, backgroundColor: 'transparent', color: '#fff' }}>Refuser</button>
        </div>
      </div>
    </div>
  );
}
